import { Link } from 'react-router-dom';
import { ArrowRight, SearchX } from 'lucide-react';
import Metadata from '../components/Metadata';
import PageHero from '../components/PageHero';
import { assets, pageMeta } from '../data/siteData';
import { assetUrl } from '../lib/media';

export default function NotFoundPage() {
  return (
    <>
      <Metadata
        title={pageMeta.notFound.title}
        description={pageMeta.notFound.description}
        image={assetUrl(pageMeta.notFound.ogImage, 1200)}
        path="/404"
        noindex
      />

      <PageHero
        eyebrow="404"
        title="Siden blev ikke fundet"
        description="Den side, du søgte, findes ikke længere eller er flyttet. Brug knapperne herunder for at komme videre til hjemmesiden eller se vores ydelser."
        image={assets.terrace}
        primaryAction={{ label: 'Til forsiden', to: '/' }}
        secondaryAction={{ label: 'Se ydelser', to: '/ydelser' }}
      />

      <section className="bg-brand-gray-50 py-16">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-4 sm:grid-cols-2">
            <article className="border border-brand-gray-200 bg-white p-6">
              <SearchX className="h-10 w-10 text-brand-orange" />
              <h2 className="mt-4 font-display text-2xl font-bold text-brand-black">Tilbage til forsiden</h2>
              <p className="mt-3 text-sm leading-7 text-brand-gray-600">Start her, hvis du vil videre til forside, kontakt eller galleriet.</p>
              <Link to="/" className="mt-5 inline-flex items-center justify-center bg-brand-black px-5 py-3 text-xs font-bold uppercase tracking-[0.18em] text-white transition-colors hover:bg-brand-orange">
                Gå til forsiden
                <ArrowRight className="ml-3 h-4 w-4" />
              </Link>
            </article>

            <article className="border border-brand-gray-200 bg-white p-6">
              <SearchX className="h-10 w-10 text-brand-orange" />
              <h2 className="mt-4 font-display text-2xl font-bold text-brand-black">Se vores ydelser</h2>
              <p className="mt-3 text-sm leading-7 text-brand-gray-600">Du kan hurtigt finde den rigtige underside for træterrasser, renovering, tagudskiftning eller vinduer og døre.</p>
              <Link to="/ydelser" className="mt-5 inline-flex items-center justify-center border border-brand-gray-200 px-5 py-3 text-xs font-bold uppercase tracking-[0.18em] text-brand-black transition-colors hover:border-brand-orange hover:text-brand-orange">
                Gå til ydelser
              </Link>
            </article>
          </div>
        </div>
      </section>
    </>
  );
}
